__turbopack_context__.v({
  "body_rich_text": "LoadMoreButton-module-scss-module__Q91tdW__body_rich_text",
  "container": "LoadMoreButton-module-scss-module__Q91tdW__container",
  "direction__column": "LoadMoreButton-module-scss-module__Q91tdW__direction__column",
  "direction__row": "LoadMoreButton-module-scss-module__Q91tdW__direction__row",
  "gradient-glow-blue": "LoadMoreButton-module-scss-module__Q91tdW__gradient-glow-blue",
  "gradient-glow-neon": "LoadMoreButton-module-scss-module__Q91tdW__gradient-glow-neon",
  "gradient-glow-orange": "LoadMoreButton-module-scss-module__Q91tdW__gradient-glow-orange",
  "gradient-glow-pink": "LoadMoreButton-module-scss-module__Q91tdW__gradient-glow-pink",
  "gradient-glow-snap-pea": "LoadMoreButton-module-scss-module__Q91tdW__gradient-glow-snap-pea",
  "gradient-neon-pink": "LoadMoreButton-module-scss-module__Q91tdW__gradient-neon-pink",
  "gradient-pink-blue": "LoadMoreButton-module-scss-module__Q91tdW__gradient-pink-blue",
  "gradient-pink-orange": "LoadMoreButton-module-scss-module__Q91tdW__gradient-pink-orange",
  "layout__content-leading": "LoadMoreButton-module-scss-module__Q91tdW__layout__content-leading",
  "layout__content-trailing": "LoadMoreButton-module-scss-module__Q91tdW__layout__content-trailing",
  "module-base": "LoadMoreButton-module-scss-module__Q91tdW__module-base",
  "module-content-swap": "LoadMoreButton-module-scss-module__Q91tdW__module-content-swap",
  "module_block__contained": "LoadMoreButton-module-scss-module__Q91tdW__module_block__contained",
  "module_block__uncontained": "LoadMoreButton-module-scss-module__Q91tdW__module_block__uncontained",
  "module_breadcrumbs": "LoadMoreButton-module-scss-module__Q91tdW__module_breadcrumbs",
  "section_bg_fill__base": "LoadMoreButton-module-scss-module__Q91tdW__section_bg_fill__base",
  "section_bg_fill__gradient": "LoadMoreButton-module-scss-module__Q91tdW__section_bg_fill__gradient",
  "section_bg_fill__no-fill": "LoadMoreButton-module-scss-module__Q91tdW__section_bg_fill__no-fill",
  "section_bg_fill__raised": "LoadMoreButton-module-scss-module__Q91tdW__section_bg_fill__raised",
  "section_container": "LoadMoreButton-module-scss-module__Q91tdW__section_container",
  "with_breadcrumb": "LoadMoreButton-module-scss-module__Q91tdW__with_breadcrumb",
  "with_navbar": "LoadMoreButton-module-scss-module__Q91tdW__with_navbar",
});
